export function initMenu() {
  const button = document.querySelector(".header__menu-btn");
  const nav = document.querySelector(".header__nav");
  if (!button || !nav) return;

  const close = () => {
    nav.classList.remove("is--open");
    button.setAttribute("aria-expanded", "false");
  };

  const toggle = () => {
    const isOpen = nav.classList.toggle("is--open");
    button.setAttribute("aria-expanded", String(isOpen));
  };

  button.addEventListener("click", toggle);

  document.addEventListener("click", (e) => {
    if (!nav.classList.contains("is--open")) return;
    if (nav.contains(e.target) || button.contains(e.target)) return;
    close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", close);
  });
}
